document.addEventListener('DOMContentLoaded', function () {
  initMobileMenu();
  initProductGallery();
  initQuantitySelectors();
  initCartQuantityUpdates();
  initSmoothScroll();
  initCollectionSort();
  initAjaxAddToCart();
});

/**
 * Mobile menu: toggles `.is-open` on the menu and `.menu-open` on body.
 * Closes on overlay click or close-button click.
 */
function initMobileMenu() {
  var toggle = document.querySelector('.mobile-menu-toggle');
  var menu = document.querySelector('.mobile-menu');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', function () {
    menu.classList.add('is-open');
    document.body.classList.add('menu-open');
  });

  var closeBtn = menu.querySelector('.mobile-menu__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      closeMenu();
    });
  }

  document.addEventListener('click', function (e) {
    if (!menu.classList.contains('is-open')) return;
    if (menu.contains(e.target) || toggle.contains(e.target)) return;
    closeMenu();
  });

  function closeMenu() {
    menu.classList.remove('is-open');
    document.body.classList.remove('menu-open');
  }
}

/**
 * Product image gallery: clicking a thumbnail swaps the main image
 * src/srcset and marks the thumbnail as active.
 */
function initProductGallery() {
  var mainImage = document.querySelector('.product-gallery__main-image');
  var gallery = document.querySelector('.product-gallery');

  if (!mainImage || !gallery) return;

  gallery.addEventListener('click', function (e) {
    var thumbnail = e.target.closest('.product-gallery__thumbnail');
    if (!thumbnail) return;

    var src = thumbnail.dataset.src || thumbnail.src;
    var srcset = thumbnail.dataset.srcset || '';

    if (src) {
      mainImage.src = src;
    }
    if (srcset) {
      mainImage.srcset = srcset;
    } else {
      mainImage.removeAttribute('srcset');
    }

    var thumbnails = gallery.querySelectorAll('.product-gallery__thumbnail');
    for (var i = 0; i < thumbnails.length; i++) {
      thumbnails[i].classList.remove('active');
    }
    thumbnail.classList.add('active');
  });
}

/**
 * Quantity selector: plus/minus buttons adjust the input value.
 * Minimum value is 1.
 */
function initQuantitySelectors() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quantity-selector__btn');
    if (!btn) return;

    var selector = btn.closest('.quantity-selector');
    if (!selector) return;

    var input = selector.querySelector('.quantity-selector__input');
    if (!input) return;

    var currentValue = parseInt(input.value, 10) || 1;

    if (btn.dataset.action === 'decrease' || btn.textContent.trim() === '-') {
      currentValue = Math.max(1, currentValue - 1);
    } else {
      currentValue = currentValue + 1;
    }

    input.value = currentValue;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

/**
 * Cart quantity updates: debounced auto-submit when a cart item
 * quantity input changes.
 */
function initCartQuantityUpdates() {
  var debounceTimers = {};

  document.addEventListener('change', function (e) {
    var input = e.target.closest('.cart-item__quantity');
    if (!input) return;

    var form = input.closest('form');
    if (!form) return;

    var inputId = input.name || input.id || 'default';

    if (debounceTimers[inputId]) {
      clearTimeout(debounceTimers[inputId]);
    }

    debounceTimers[inputId] = setTimeout(function () {
      form.submit();
    }, 500);
  });
}

/**
 * Smooth scroll for same-page anchor links.
 */
function initSmoothScroll() {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;

    var targetId = link.getAttribute('href');
    if (targetId === '#') return;

    var target = document.querySelector(targetId);
    if (!target) return;

    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
  });
}

/**
 * AJAX add-to-cart: intercepts the product form submit,
 * sends to /cart/add.js, shows notification, updates header cart count.
 */
function initAjaxAddToCart() {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var submitBtn = form.querySelector('.product-page__submit');
    var notification = document.querySelector('[data-cart-notification]');
    var notificationText = notification ? notification.querySelector('[data-cart-notification-text]') : null;

    var variantInput = form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');
    var quantityInput = form.querySelector('.quantity-selector__input');

    var variantId = variantInput ? variantInput.value : null;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (!variantId) return;

    submitBtn.classList.add('is-loading');
    submitBtn.textContent = 'Toevoegen...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(function () {
      return fetch('/cart.js');
    })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      showNotification(notification, notificationText, 'Toegevoegd aan winkelwagen', 'is-success');
      submitBtn.classList.remove('is-loading');
      submitBtn.textContent = 'In winkelwagen';
    })
    .catch(function () {
      showNotification(notification, notificationText, 'Er ging iets mis, probeer het opnieuw', 'is-error');
      submitBtn.classList.remove('is-loading');
      submitBtn.textContent = 'In winkelwagen';
    });
  });
}

function updateCartCount(count) {
  var badge = document.querySelector('.header__cart-count');
  if (count > 0) {
    if (!badge) {
      var cartLink = document.querySelector('.header__cart');
      if (cartLink) {
        badge = document.createElement('span');
        badge.className = 'header__cart-count';
        cartLink.appendChild(badge);
      }
    }
    if (badge) badge.textContent = count;
  } else if (badge) {
    badge.remove();
  }
}

function showNotification(el, textEl, message, className) {
  if (!el || !textEl) return;
  el.classList.remove('is-visible', 'is-success', 'is-error');
  textEl.textContent = message;
  el.classList.add('is-visible', className);
  setTimeout(function () {
    el.classList.remove('is-visible', className);
  }, 3000);
}

/**
 * Collection sort: redirects to the current page with an updated
 * sort_by query parameter.
 */
function initCollectionSort() {
  var select = document.querySelector('.collection-sort__select');
  if (!select) return;

  select.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.href = url.toString();
  });
}
